import Header from "../Header";
import Footer from "../Footer";
import apps from "../../images/custom-applications.png";

function CustomApplications() {

    return (
        <div className={"sub-service page"}>
            <Header/>
            <div className={"small-heading"}>CUSTOM APPLICATIONS</div>
            <div className={"content"}>
                <div className={"sub-service-page-text"}>
                    <img className={"service-section-service-image scale-up margin-bottom-2"} src={apps}
                         alt={"custom-applications"}/>
                    <div className={"section open slide-in-top"}>
                        <div className={"section-subheading"}>Software Built Around Your Business</div>
                        <p className={"section-content"}>
                            Off-the-shelf software rarely fits exactly how you work. We build custom applications
                            designed around your process, so your tools match your business instead of the other way
                            around.
                        </p>
                        <div className={"section-subheading"}>What Are Custom Applications?</div>
                        <p className={"section-content"}>
                            A custom application is software built specifically for your needs, from a simple internal
                            tool to a full web app used by your customers. It can connect to the systems you already
                            rely on and include automation and AI features where they help.
                            <br/>
                            We handle everything from design to launch, and we take care of the hosting and
                            maintenance for everything we build.
                        </p>
                        <div className={"section-subheading"}>What We Can Build</div>
                        <div className={"section-content"}>
                            <div className={"bullet-point"}>
                                <span className={"bold"}>• Web Applications</span> – Full-featured apps your customers
                                or team can use from any browser.
                            </div>
                            <div className={"bullet-point"}>
                                <span className={"bold"}>• Internal Tools</span> – Replace spreadsheets and manual
                                processes with tools built for the way your team works.
                            </div>
                            <div className={"bullet-point"}>
                                <span className={"bold"}>• Dashboards and Reporting</span> – See your key numbers in one
                                place, updated automatically.
                            </div>
                            <div className={"bullet-point"}>
                                <span className={"bold"}>• Client Portals</span> – Give your clients a secure place to
                                log in, view their information, and make payments.
                            </div>
                            Contact us today to talk through the application you have in mind.
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    )
}

export default CustomApplications;
